export const actionTypes: any = {
  // get sub category
  GET_GENERAL_APPLICATIONS_START: 'GET_GENERAL_APPLICATIONS_START',
  GET_GENERAL_APPLICATIONS_SUCCESS: 'GET_GENERAL_APPLICATIONS_SUCCESS',
  GET_GENERAL_APPLICATIONS_FINISH: 'GET_GENERAL_APPLICATIONS_FINISH',

  // get File csv xlsx
  GET_GENERAL_APPLICATIONS_FILE_START: 'GET_GENERAL_APPLICATIONS_FILE_START',
  GET_GENERAL_APPLICATIONS_FILE_SUCCESS: 'GET_GENERAL_APPLICATIONS_FILE_SUCCESS',
  GET_GENERAL_APPLICATIONS_FILE_FINISH: 'GET_GENERAL_APPLICATIONS_FILE_FINISH',

  // ADD sub category
  ADD_GENERAL_APPLICATIONS_START: 'ADD_GENERAL_APPLICATIONS_START',
  ADD_GENERAL_APPLICATIONS_SUCCESS: 'ADD_GENERAL_APPLICATIONS_SUCCESS',
  ADD_GENERAL_APPLICATIONS_FINISH: 'ADD_GENERAL_APPLICATIONS_FINISH',
  ADD_GENERAL_APPLICATIONS_RESET: 'ADD_GENERAL_APPLICATIONS_RESET',

  // Update sub category
  UPDATE_GENERAL_APPLICATIONS_START: 'UPDATE_GENERAL_APPLICATIONS_START',
  UPDATE_GENERAL_APPLICATIONS_SUCCESS: 'UPDATE_GENERAL_APPLICATIONS_SUCCESS',
  UPDATE_GENERAL_APPLICATIONS_FINISH: 'UPDATE_GENERAL_APPLICATIONS_FINISH',
  UPDATE_GENERAL_APPLICATIONS_RESET: 'UPDATE_GENERAL_APPLICATIONS_RESET',

  // delete sub category
  DELETE_GENERAL_APPLICATIONS_START: 'DELETE_GENERAL_APPLICATIONS_START',
  DELETE_GENERAL_APPLICATIONS_SUCCESS: 'DELETE_GENERAL_APPLICATIONS_SUCCESS',
  DELETE_GENERAL_APPLICATIONS_FINISH: 'DELETE_GENERAL_APPLICATIONS_FINISH',

  // Enable GENERAL_APPLICATIONS
  ENABLE_GENERAL_APPLICATIONS_REQUEST: 'ENABLE_GENERAL_APPLICATIONS_REQUEST',
  ENABLE_GENERAL_APPLICATIONS_SUCCESS: 'ENABLE_GENERAL_APPLICATIONS_SUCCESS',
  ENABLE_GENERAL_APPLICATIONS_FINISH: 'ENABLE_GENERAL_APPLICATIONS_FINISH',

  // Disable GENERAL_APPLICATIONS
  DISABLE_GENERAL_APPLICATIONS_REQUEST: 'DISABLE_GENERAL_APPLICATIONS_REQUEST',
  DISABLE_GENERAL_APPLICATIONS_SUCCESS: 'DISABLE_GENERAL_APPLICATIONS_SUCCESS',
  DISABLE_GENERAL_APPLICATIONS_FINISH: 'DISABLE_GENERAL_APPLICATIONS_FINISH',

  // single active sub category
  SINGLE_ACTIVATE_GENERAL_APPLICATIONS_REQUEST: 'SINGLE_ACTIVATE_GENERAL_APPLICATIONS_REQUEST',
  SINGLE_ACTIVATE_GENERAL_APPLICATIONS_SUCCESS: 'SINGLE_ACTIVATE_GENERAL_APPLICATIONS_SUCCESS',
  SINGLE_ACTIVATE_GENERAL_APPLICATIONS_FINISH: 'SINGLE_ACTIVATE_GENERAL_APPLICATIONS_FINISH',

  // single deactive sub category
  SINGLE_DEACTIVATE_GENERAL_APPLICATIONS_REQUEST: 'SINGLE_DEACTIVATE_GENERAL_APPLICATIONS_REQUEST',
  SINGLE_DEACTIVATE_GENERAL_APPLICATIONS_SUCCESS: 'SINGLE_DEACTIVATE_GENERAL_APPLICATIONS_SUCCESS',
  SINGLE_DEACTIVATE_GENERAL_APPLICATIONS_FINISH: 'SINGLE_DEACTIVATE_GENERAL_APPLICATIONS_FINISH',
}
